module.exports = __webpack_public_path__ + "media/components/country-flag/static/dk-b479701c144285c384c126e6fdf53364.svg";